"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_ERROR_CODES = void 0;
var createSupplierConfig_1 = require("./use-cases/createSupplierConfig");
var editSupplierConfig_1 = require("./use-cases/editSupplierConfig");
var manualFinishBookingFeeOrder_1 = require("./use-cases/manualFinishBookingFeeOrder");
var manualOrderTravelReprocess_1 = require("./use-cases/manualOrderTravelReprocess");
var replicateSupplierConfigs_1 = require("./use-cases/replicateSupplierConfigs");
exports.SUPPORT_ERROR_CODES = {
    SUPPLIER_CONFIG_REPLICATION: replicateSupplierConfigs_1.SUPPLIER_CONFIG_REPLICATION,
    SUPPLIER_CONFIG_CREATE: createSupplierConfig_1.SUPPLIER_CONFIG_CREATE,
    SUPPLIER_CONFIG_EDIT: editSupplierConfig_1.SUPPLIER_CONFIG_EDIT,
    MANUAL_ORDER_TRAVEL_REPROCESS: manualOrderTravelReprocess_1.MANUAL_ORDER_TRAVEL_REPROCESS,
    MANUAL_FINISH_BOOKING_FEE_ORDER: manualFinishBookingFeeOrder_1.MANUAL_FINISH_BOOKING_FEE_ORDER
};
